<template>
    <Carousel class="" :perPage="perPage" :autoplay="autoplay" :autoplayHoverPause="autoplayHoverPause" :loop="loop" :paginationEnabled="paginationEnabled" :autoplayTimeout="autoplayTimeout">
        <Slide class="slide" v-for="pic in pics" :key="pic.pathLong">
            <div class="image-slide" :class="{ home: homeProp ? true : false, backstyle: fill ? true : false}" :style="{ backgroundImage: `url(${pic.pathLong})`}"></div>
        </Slide>
    </Carousel>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel';
export default {
    name: 'carousel',
    data () {
        return {
            perPage: 1,
            autoplay: true,
            autoplayTimeout: 2000,
            autoplayHoverPause: false,
            loop: true,
            paginationEnabled: true,
            fill: true
        }
    },
    props:['pics', 'homeProp', 'perPageCount', 'fillBool', 'fast'],
    components: {
      Carousel,
      Slide
    },
    methods: {
    },
    mounted: function() {
        this.fill = this.fillBool
        this.autoplayTimeout = this.fast
        this.perPage = this.perPageCount
        console.log(this.pics)
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style >
.VueCarousel-dot-container {
    margin-top: 10px !important;
}
.VueCarousel-dot{
    margin: 0px !important;
    height: 5px !important;
    width: 5px !important;
}
.backstyle {
    max-height: 100px;
    -webkit-background-size: contain;
    -moz-background-size: contain;
    -o-background-size: contain;
    background-size: contain;
}
.image-slide {
    height: 20vh;
    width: auto;
    /* background: url(https://images.unsplash.com/photo-1497366811353-6870744d04b2?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1350&q=80); */
    background-position-x: center;
    background-position-y: center;
    background-repeat: no-repeat;
    /* background-position: fixed; */
}
.home {
    height: 75vh;
    width: 100%;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
}
image-slide > img {
    height: 50vh;
    /* max-height: 80vh;
    min-height: 40vh; */
}
</style>
